/**
 * @module jss
 *
 * Create and manipulate CSS in JS.
 *
 * @see https://docs.tss-react.dev
 */
import combineStyles from 'classnames';
import { useTheme, lighten, darken } from '@mui/material/styles';
import { makeStyles } from './makeStyles';

export const jss = {
  combineStyles,
  makeStyles,
  useTheme,
  lighten,
  darken,
};
